import { Injectable } from '@angular/core';
import { HttpClient } from '@angular/common/http';
import { environment } from '@environments/environment';
import { Observable } from 'rxjs';

import { SayfalamaSonuc } from '@models/genel/SayfalamaSonuc';
import { IslemSonuc } from '@core/models/genel/IslemSonuc';
import { KarayoluEbiletInfo } from '@core/models/ebilet/KarayoluEbiletInfo';


@Injectable()
export class EbiletService {
  constructor(private http: HttpClient) {
  }

  getData(parametersModel): Observable<SayfalamaSonuc> {
    return this.http.get<SayfalamaSonuc>(environment.API_KARAYOLUEBILET_URL, { params: parametersModel });
  }

  ekleGuncelle(KarayoluEbiletInfo: KarayoluEbiletInfo): Observable<IslemSonuc> {
    return this.http.post<IslemSonuc>(environment.API_KARAYOLUEBILET_URL + 'ekle/', KarayoluEbiletInfo);
  }

  iptalEt(KarayoluEbiletInfo: KarayoluEbiletInfo): Observable<IslemSonuc> {
    return this.http.post<IslemSonuc>(environment.API_KARAYOLUEBILET_URL + 'iptal/', KarayoluEbiletInfo);
  }

  getBelgeTipleri(): Observable<IslemSonuc> {
    // return this.http.post<IslemSonuc>(this.srvUrl + 'belge/',null );
    return null;
  }

  getHizmetNevileri(): Observable<IslemSonuc> {
    return this.http.get<IslemSonuc>(environment.API_KARAYOLUEBILET_URL + 'hizmet/');
  }

  get(id: number): Observable<KarayoluEbiletInfo> {
    return this.http.get<KarayoluEbiletInfo>(environment.API_KARAYOLUEBILET_URL + id.toString());
  }

  sil(id: number): Observable<KarayoluEbiletInfo> {
    return this.http.delete<KarayoluEbiletInfo>(environment.API_KARAYOLUEBILET_URL + id.toString());
  }

}
